import { useQuery } from '@tanstack/react-query';

import useApi from '../use-api';

import type {
  ISmsResponsesFilters,
  ISmsCampaignAnswerData,
} from 'infrastructure/interfaces';

const apiUrl = 'core-2/patients/sms-campaign/response';

export const useSmsCampaignsAnswersData = ({
  groupName: _,
  language: __,
  ...filters
}: ISmsResponsesFilters) => {
  const queryKey = [apiUrl, filters] as const;

  const pageSize = 100;

  const { loadData } = useApi();

  const { data, error, isLoading, isPreviousData } = useQuery({
    queryKey,
    keepPreviousData: true,
    queryFn: async () => {
      const res = await loadData<ISmsCampaignAnswerData, ISmsResponsesFilters>(
        apiUrl,
        {
          ...filters,
          items: pageSize,
        },
      );
      return res;
    },
    enabled: Boolean(filters.campaignGuid),
  });

  return {
    data: {
      data: data?.data ?? [],
      count: data?.count ?? 0,
    },
    isLoading: isLoading || isPreviousData,
    error,
    isPreviousData,
    pageSize,
  };
};
